<template>
    <div class="main">
      
      <!-- <span v-if="user != null" class="logout"> <span>Hi {{user.first_name}} {{user.last_name}}</span>, <span class='link'><a href="/logout">Log out</a></span></span> -->
      <div class="calendar" v-if="cadence.length > 0">
        <h1><!-- Employee Portal - Weekly Survey -->
          {{cadence[0].formlabel}}
        </h1>
        <div class="tabs" v-if="formID != 2">
          <div v-if="surveyCadenceIndex == -1" class="tabGroup">
            <div :class="{'active': (activeTab=='open') }" class="tab open" @click="activeTab = 'open'">Open Weeks</div>
            <div :class="{'active': (activeTab=='close') }"  class="tab close" @click="activeTab = 'close'">Closed Weeks</div>
          </div>
          <div v-else class="control">
            <span @click="surveyCadenceIndex = -1">Back</span>
          </div>
        </div>

        <div v-if="cadence.length > 0 && surveyCadenceIndex == -1" class='previousWeeks' :class="activeTab " >
          <table>
            <thead>
                <th>DATE RANGE</th>
                <th>LINK</th>
                <th>STATUS</th>
            </thead> 
            <tbody>
              <template v-for="(week, index) in cadence" :key="week.id" >
                <tr class="week" v-if="(this.activeTab == 'open' && week.lock_date == null) || (this.activeTab == 'close' && week.lock_date != null)">
                  <td>{{week.label}}</td> 
                  <td><button @click="enterSurvey(index)"><span v-if="week.lock_date != null">VIEW ONLY</span><span v-else-if="week.lock_date == null && week.alreadySubmitted">UPDATE</span><span v-else>ENTER SURVEY</span></button>
                  <div class="wrapper" v-if="week.justSubmmited"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
  </svg></div>
                  </td>
                  <td><span v-if="week.alreadySubmitted">COMPLETED</span><span v-else-if="!week.alreadySubmitted">INCOMPLETE</span></td>
                </tr> 
              </template>
            </tbody>
          </table>
        </div>
        <div v-if="surveyCadenceIndex != -1" class="survey">
          <span class="dateLabel" v-if="surveyCadenceIndex != -1 && cadence.length > 0">{{cadence[surveyCadenceIndex].label}}</span>
          <weeklyTime 
            v-if="formID==1 && answers != null" 
            :answers="answers"
            :readOnly="cadence[surveyCadenceIndex].lock_date != null" 
            @backToSurvey="backToSurveyMain"
            @submitSurvey="submitSurvey">
          </weeklyTime>
          <mealBreakWaiver 
            v-if="formID==2 && answers != null" 
            :answers="answers"
            :readOnly="cadence[surveyCadenceIndex].lock_date != null" 
            @backToSurvey="backToSurveyMain"
            @submitSurvey="submitSurvey">
          </mealBreakWaiver>
        </div>
      </div>
    </div>
  </template>
  
<script>
  import weeklyTime from '../components/forms/weeklyTime.vue'
  import mealBreakWaiver from '../components/forms/mealBreakWaiver.vue'

  import Cookies from 'js-cookie'

  export default {
    name: 'MainView',
    props: {
      msg: String
    },
    data() {
      return {
        cadence: [],
        user: null,
        formID: this.$route.params.id,
        surveyCadenceIndex: -1,
        // questions:null,
        answers:null,
        activeTab: 'open'
      }
    },
      components: {
    // HelloWorld
        weeklyTime,
        mealBreakWaiver
    },
    methods: {
      submitSurvey(questionsanswers) {
        console.log(questionsanswers)
        let token = this.getSiteCookie('btoken')
        //   // let url = process.env.VUE_APP_API_BASE_URL+'/form/'+this.formID+'/cadence/'+this.cadence[this.selectedWeekIndex].id
        let url = process.env.VUE_APP_API_BASE_URL+'/form/'+this.formID+'/cadence/'+this.cadence[this.surveyCadenceIndex].id + '/submit'
        // this.srcQuestionsObj.questions = this.questions
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url,
          data: {questions: questionsanswers},
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        };
        this.$emit('displayGlobalMessage', {message:'Saving Survey.', on: true, animate: true})
        this.axios.request(config).then((response) => { 
          if(!response.data.success) {
            this.$emit('displayGlobalMessage', {message:'something is wrong', on: true, animate: false})
          } else {
            this.$emit('displayGlobalMessage', {message:'Survey Saved', on: true, animate: false})
            this.cadence[this.surveyCadenceIndex].alreadySubmitted = true
            this.cadence[this.surveyCadenceIndex].justSubmmited = true
            this.surveyCadenceIndex = -1
            this.answers = null
          }
          setTimeout(()=>this.$emit('displayGlobalMessage', {message:'', on: false, animate: false}), 1)
        })
      },
      backToSurveyMain() {
        this.surveyCadenceIndex = -1
        this.answers = null
      },
      enterSurvey(surveyCadenceIndex) {
        this.surveyCadenceIndex = surveyCadenceIndex
        this.cadence.map(c=>c.justSubmmited=false)
        if(surveyCadenceIndex != -1)
          this.getQuestions()
      },
      getQuestions() {
        let token = this.getSiteCookie('btoken')
        // this.user = localStorage.getItem(token)
        let that = this
        // if(this.user != undefined)
        //   this.user = JSON.parse(this.user)
        
        // data: this.questions,
        if(token != undefined && localStorage.getItem(token) != undefined) {
          let url = process.env.VUE_APP_API_BASE_URL+'/form/'+this.formID+'/cadence/'+this.cadence[this.surveyCadenceIndex].id
          let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url,
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          };
          this.$emit('displayGlobalMessage', {message:'Preparing survey.', on: true})
          this.axios.request(config).then((response) => { 
            if(response.data.success) {
              console.log(response.data.data)
              if(response.data.data[0].answers.length != 0) {
                console.log(response.data.data[0].answers)
                that.answers = response.data.data[0].answers
              } else 
                that.answers = []
            } else {
              // this.questions = response.data.data.filter(q=>q.type != 'header' && q.type != 'content')
              // this.formHeader = response.data.data.filter(q=>q.type == 'header')
              // this.formFooter = response.data.data.filter(q=>q.type == 'content')
            }
            this.$emit('displayGlobalMessage', {message:'', on: 0})
          })
        }
      },
      getSchedule() {
        console.log('getschedule')
        let token = this.getSiteCookie('btoken'), that = this
        // this.user = localStorage.getItem(token)
        // if(this.user != undefined)
        //   this.user = JSON.parse(this.user)
        
        if(token != undefined && localStorage.getItem(token) != undefined) {
          let url = process.env.VUE_APP_API_BASE_URL+'/form/'+this.formID+'/cadence'
          let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url,
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          };
          // this.$emit.displayGlobalMessage({message:'loading', duration:1000})
          this.$emit('displayGlobalMessage', {message:'Preparing survey.', on: true})
          this.axios.request(config).then((response) => { 
            if(!response.data.success) {
              console.log(response)
            } else {
              this.cadence = response.data.data
              console.log('update cadence see if its already been submitted')
              
              for(let i = 0; i < that.cadence.length; i ++) {
                this.cadence[i].justSubmmited = false
                let url = process.env.VUE_APP_API_BASE_URL+'/form/'+this.formID+'/cadence/'+this.cadence[i].id
                let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url,
                headers: { 
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
                };
                this.$emit('displayGlobalMessage', {message:'Preparing survey.', on: true})
                this.axios.request(config).then((response) => { 
                  if(response.data.success) {
                    if(response.data.data[0].answers.length > 0)
                      that.cadence[i].alreadySubmitted = true
                    else
                      that.cadence[i].alreadySubmitted = false
                  }
                })
              }
            }
            // setTimeout(()=>this.$emit('displayGlobalMessage', {message:'', on: false}), 10000)
            this.$emit('displayGlobalMessage', {message:'', on: false})
          })
        }
      },
      getSiteCookie(name) {
        const value = Cookies.get(name);
        return value
      },
      formateDate(timestamp) {
        let dateObj = new Date(timestamp)
        return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`
      },
      // submitForm(){
      //   let token = this.getSiteCookie('btoken')
      //   this.user = localStorage.getItem(token)
      //   if(this.user != undefined)
      //     this.user = JSON.parse(this.user)
        
      //   if(token != undefined && localStorage.getItem(token) != undefined) {
      //     let url = process.env.VUE_APP_API_BASE_URL+'/form/1/submit'
      //     let config = {
      //       method: 'post',
      //       maxBodyLength: Infinity,
      //       url,
      //       headers: { 
      //         'Authorization': `Bearer ${token}`,
      //         'Content-Type': 'application/json'
      //       }
      //     };
      //     this.axios.request(config).then((response) => { 
      //       if(!response.data.success) {
      //         console.log(response)


      //       } else {
      //         this.cadence = response.data.data
      //       }
      //     })
      //   }
      // }
    },
    // watch: {
    //   surveyCadenceIndex (newSurveyCadenceIndex, oldSurveyCadenceIndex) {
    //     console.log(oldSurveyCadenceIndex, newSurveyCadenceIndex)
    //     if(newSurveyCadenceIndex != -1)
    //       this.getQuestions()
    //   }
    // },
    computed: {
      filteredCadance() {
        if(this.activeTab == 'open') 
          return this.cadence.filter(c=>c.lock_date == null)
        else 
          return this.cadence.filter(c=>c.lock_date != null)
      }
    },
     mounted() {
      console.log('mounted')
      console.log(process.env, 'envionment varsxxx')
      this.getSchedule()
      // this.$emit('displayGlobalMessage', {message:'hi there', duration: 1000})
    }
  }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only --> 
  <style scoped lang="scss">
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: black;
    font-weight:normal;
  }


  .main{
    display:block;
    position:relative;

    .calendar {
      position:relative;
      text-align:left;
      h1{
        text-align: center;;
      }
      .tabs{
        display:block;
        /* border-bottom:1px solid #ccc; */
        .control{
          display: block;
          padding: 10px;
          text-align: center;
          font-weight: bold;
          text-decoration: underline;
          text-transform: uppercase;
          cursor: pointer;
        }
        .tab{
          border: 1px solid #ccc;
          border-bottom: 0;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          display: inline-block;
          width: 20%;
          vertical-align: middle;
          padding: 10px;
          margin-right: 0;
          cursor: pointer;
          box-sizing: border-box;
        }
        .tab.close {
          background-color:rgb(42 112 165 / 10%);
          /* border:2px solid #c; */
        }
        .tab.open {
          color:#000;
          background-color: rgba(165, 163, 42, 10%);
          
          border-left:0;
          /* border:2px solid #000; */
        }
        .tab.active{
          font-weight:bold;
        }
         /* .tab:hover */
      }
      .previousWeeks {
        display:block;
        height: 552px;
        overflow-y: scroll;
        /* border:1px solid #ccc; */
      }
      .previousWeeks.open{
        background-color:rgba(165, 163, 42, 5%);
      }
      .previousWeeks.close{
        background-color:rgb(42 112 165 / 5%);
      }
      position: relative;
      text-align: left;
      /* padding: 15px; */
   
      border-collapse: collapse;
      table{
        width:100%;
        border-spacing:0;
        th {
          border-bottom:1px solid #ccc;
          border-top:1px solid #ccc;
        }
        th, td {

          color:black;
          padding:10px;
        }
        td {
          border-bottom:1px solid #ebebeb;
        }
      }
      button.backToMainBtn{
        position:relative;
        right:10px; 
        top: 10px;
      }
      .survey {
        
        text-align:justify;
        padding:20px 50px;
        box-sizing: border-box;
        margin:30px auto;
        max-width:800px;
        border:1px solid #ebebeb;
        position:relative;
        box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
        background-color:#a5a32a1f;
        .dateLabel {
          font-weight: bold;
          text-align: center;
          display: block;
          padding: 20px 0;
        }
        .header {
          padding:5px 0;
          display:block;
        }

        .form {
          .question {
            text-align: left;
            display:list-item;
            list-style-type: decimal;
            padding:0 0 15px 0;
            padding-left:30px;
            margin-left:15px;

            .questionHeader{
              display:block;
            }

            .questionAnswer {
              display: inline-block;
              padding: 10px;
              /* border: 1px solid red; */
              margin: 0;
              .selection {
                display:inline-block;
                vertical-align: middle;
                padding-right:10px;
                span{
                  display:inline-block;
                  vertical-align: middle;;
                }
                input {
                  display: inline-block;
                  vertical-align: middle;
                  margin: 0 10px 0 3px;
                }
              }
              

            }
            .subquestions{
              display:block;
              /* padding-left:30px; */
              .subquestion{
                padding-top:20px;
                span{
                  display:inline-block;
                }
                input{
                  display:block;
                  width:500px;
                  max-width: 80%;
                }
              }
            }
          }
        }
      }

    }
  }
  </style>
  